import React from 'react';

export const PlusIcon = () => (
  <svg width={18} style={{ verticalAlign: 'middle' }} viewBox="0 0 14 14">
    <circle cx="7" cy="7" r="6" stroke="none" strokeWidth="2" fill="#f4f4f8" />

    <line x1="4" y1="7" x2="10" y2="7" stroke="#333" strokeWidth="1" />
    <line x1="7" y1="4" x2="7" y2="10" stroke="#333" strokeWidth="1" />
  </svg>
);
